import { CreateUserProps, CreateUserFormError } from 'modules/auth/users/store/actionType';
import { isValidEmail } from './emailValidator';
import { isValidMobileNumber } from './mobileNumberValidator';

export const createUserValidator = (formData: CreateUserProps): CreateUserFormError => {
    let errors: CreateUserFormError = {
        name: null,
        mobile_no: null,
        password: null,
        confirm_password: null,
        emailOrMobile: null
    };
    if (!formData.name || !formData.name.trim()) {
        errors.name = 'Enter full name';
    }

    if (!formData.mobile_no || !formData.mobile_no.trim()) {
        errors.mobile_no = 'Please provide mobile number';
    }

    if (!formData.email || !formData.email.trim()) {
        errors.email = 'Please provide email address';
    }

    if (formData.mobile_no && formData.mobile_no.trim() !== '' && !isValidMobileNumber(formData.mobile_no)) {
        errors.mobile_no = 'Invalid mobile number';
    }

    if (formData.email && formData.email.trim() !== '' && !isValidEmail(formData.email)) {
        errors.email = 'Invalid email address';
    }
    if (formData.role_ids && formData.role_ids.length === 0) {
        errors.role_ids = 'Please select at least one role';
    }

    if (!formData.password || !formData.password.trim()) {
        errors.password = 'Please provide password';
    } else if (formData.password.length < 3) {
        errors.password = 'Password must be at least 3 characters long';
    }

    if (!formData.confirm_password || !formData.confirm_password.trim()) {
        errors.confirm_password = 'Please re-enter password';
    } else if (formData.password !== formData.confirm_password) {
        errors.confirm_password = 'Passwords do not match';
    }
    return errors;
};

